import { faCode } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * CodeSet item interface for ui_metadata storage
 */
export interface CodeSetItem {
  id: string;
  displayLabel: string;
  label: string;
  name?: string;
  scope?: 'COMPANY' | 'PERSONAL';
  type?: string;
}

/**
 * Transform API response to CodeSetItem format
 */
export const transformCodeSet = (apiItem: {
  id: string | number;
  label?: string;
  name?: string;
  scope?: 'COMPANY' | 'PERSONAL';
  type?: string;
}): CodeSetItem => ({
  id: String(apiItem.id),
  displayLabel: apiItem.label || apiItem.name || String(apiItem.id),
  label: apiItem.label || apiItem.name || String(apiItem.id),
  name: apiItem.name,
  scope: apiItem.scope,
  type: apiItem.type,
});

/**
 * Modal configuration for CodeSet selector
 */
export const codeSetModalConfig: GenericSelectorModalConfig<CodeSetItem> = {
  title: 'Select Code Set',
  searchPlaceholder: 'Search code sets...',
  emptyStateIcon: faCode,
  emptyStateMessage: 'No code set selected',
  noResultsMessage: (searchTerm) => `No code sets found for "${searchTerm}"`,
  colorTheme: 'pink',
  selectionMode: 'single',
  showConnectorToggle: false,
  defaultConnector: 'ALL',
  getItemLabel: (item) => item.label,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'code set',
  itemLabelPlural: 'code sets',
};

/**
 * Node display configuration for CodeSet
 */
export const codeSetNodeConfig: GenericNodeComponentConfig<CodeSetItem> = {
  colorTheme: 'pink',
  getItemLabel: (item) => item.label,
  getItemKey: (item) => item.id,
  maxVisibleItems: 1, // Single selection
  showConnectorLabel: false,
};
